var _Circle, _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgYoutubeDark(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 17.5,
    cy: 17.5,
    r: 17.06,
    fill: "#1d1c39"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.88 0 0 7.88 0 17.5S7.88 35 17.5 35 35 27.12 35 17.5 27.12 0 17.5 0z",
    fill: "#e1087e"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M26.3 13.16c-.22-.78-.82-1.38-1.6-1.6-1.43-.38-7.2-.38-7.2-.38s-5.75 0-7.2.38c-.78.22-1.38.82-1.6 1.6-.27 1.47-.41 2.95-.4 4.45 0 1.49.13 2.97.4 4.43.22.78.82 1.38 1.6 1.6 1.43.38 7.2.38 7.2.38s5.75 0 7.2-.38c.78-.22 1.38-.82 1.6-1.6.26-1.46.39-2.94.38-4.43.01-1.49-.12-2.98-.38-4.45zm-10.64 7.2v-5.51l4.8 2.76-4.8 2.75z",
    fill: "#fff"
  })));
}
export default SvgYoutubeDark;